<template>
  <div>
    <div class="postItem" v-for="(item, index) in postList" :key="index">
      <div class="column">
        <div class="header">{{ item.post }}</div>
        <div class="footer">
          <div v-show="item.zphdlx == 2">
            <br />
          </div>
          <div v-show="item.zphdlx == 1">
            {{
              (item.degreeLimit
                ? "学历要求：" + item.degreeLimit
                : "学历要求：无") +
              (item.degreeLimit ? " | " + "" : "|") +
              (item.ageLimit ? "年龄要求：" + item.ageLimit : "年龄要求：无")
            }}
          </div>
        </div>
      </div>
      <div class="column">
        <div class="header">{{ item.company }}</div>
        <div class="footer">
          {{ "计划招聘人数：" + item.planNumber + "人" }}
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="goDetails(item)">查看详情</el-button>
      </div>
      <!-- <div class="line">
        <div class="header">
          <div>{{ item.post }}</div>
          <div>{{ item.company }}</div>
        </div>
        <div class="footer">
          <div>
            {{
              item.degreeLimit + (item.ageLimit ? " | " + item.ageLimit : "")
            }}
          </div>
          <div>{{ "计划招聘人数：" + item.planNumber + "人" }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<style lang="scss" scoped>
.postItem {
  background-color: #f2f2f2;
  padding: 20px;
  margin: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .column {
    display: block;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // align-items: flex-end;
    .header {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 20px;
    }
    // .footer {
    // }
  }
  .btn {
    display: none;
    margin-right: 20px;
  }

  &:hover {
    background-color: #ffffff;
    .column {
      &:nth-child(2) {
        display: none;
      }
    }
    .btn {
      display: block;
    }
  }
}
</style>
<script>
export default {
  props: {
    postList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goDetails(item) {
      // let para = {
      //   zphdid: item.zphdid,
      //   zphdlx: item.zphdlx,
      //   gwlbid: item.gwlbid,
      //   zphdmc: item.zphdmc,
      //   company: item.company,
      //   post: item.post,
      //   planNumber: item.planNumber,
      //   gwzz: item.gwzz,
      //   degreeLimit: item.degreeLimit,
      //   zyyq: item.zyyq,
      //   ageLimit: item.ageLimit,
      //   zgtj: item.zgtj,
      //   zyjszg: item.zyjszg,
      //   zzjnjnlszyq: item.zzjnjnlszyq
      // };
      console.log(item);
      this.$router.push({
        name: "PostDetails",
        query: {
          key: JSON.stringify(item),
        },
      });
    },
  },
};
</script>
